"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.buildOnErrorCallback = void 0;
var _lodash = _interopRequireDefault(require("lodash"));
var _js = _interopRequireDefault(require("@bugsnag/js"));
var _pluginReact = _interopRequireDefault(require("@bugsnag/plugin-react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var redactedKeys = [/(First|Last|Sur|Given)Name/i, /bank/i, /expiry/i, /Gender/i, /DOB/i, /Password/i, /Medicare/i, /FlybuysNumber/i, /Email/i, /Phone/i, /line\d/i, /authorization/i];
var levelToBugsnagSeverityOverrides = {
  debug: 'info',
  silly: 'info',
  verbose: 'info',
  warn: 'warning'
};
var allowedErrorKeys = ['stack', 'message', 'name'];
var buildOnErrorCallback = function buildOnErrorCallback(level) {
  return function (event) {
    // Bugsnag documentation says to re-assign param.
    // eslint-disable-next-line no-param-reassign
    event.severity = levelToBugsnagSeverityOverrides[level] || level;
  };
};
exports.buildOnErrorCallback = buildOnErrorCallback;
var getDisallowedErrorKeys = function getDisallowedErrorKeys(error) {
  return _lodash["default"].isPlainObject(error) || _lodash["default"].isError(error) ? _lodash["default"].omit(error, allowedErrorKeys) : {};
};
var toPlainObjectDeep = function toPlainObjectDeep(obj) {
  return JSON.parse(JSON.stringify(obj));
};
var log = function log(_ref) {
  var customData = _ref.customData,
    level = _ref.level,
    message = _ref.message,
    metaData = _ref.metaData;
  var membershipId = _lodash["default"].get(customData, 'userId');
  if (membershipId) {
    _js["default"].setUser(membershipId);
  }

  // Bugsnag strips out any properties that are not a part of the base Error Class before it is sent.
  // By converting to a plain object avoids this issue.
  var plainMeta = toPlainObjectDeep(_objectSpread(_objectSpread(_objectSpread({}, metaData), _lodash["default"].get(customData, 'custom')), getDisallowedErrorKeys(message)));
  _js["default"].addMetadata('custom', plainMeta);
  return _js["default"].notify(message, buildOnErrorCallback(level));
};

/**
 * @param {{ key: string }} config - Config for this logger.
 * @param {{React: object, releaseStage: string, version: string}} options - Options applicable across loggers.
 * @returns {{getErrorBoundary: Function, log: Function}} - Methods for using this logger.
 */
var bugsnagFactory = function bugsnagFactory(config, _ref2) {
  var React = _ref2.React,
    releaseStage = _ref2.releaseStage,
    version = _ref2.version;
  // Next.js executes this code multiple times and doesn't reset modules in between subsequent runs.
  // By checking if the Bugsnag._client instance is already populated we avoid warnings about Bugsnag being called more than once.
  // eslint-disable-next-line no-underscore-dangle
  if (!_js["default"]._client) {
    _js["default"].start({
      apiKey: config.key,
      appVersion: version,
      plugins: [new _pluginReact["default"](React)],
      redactedKeys: redactedKeys,
      releaseStage: releaseStage
    });
  }
  return {
    getErrorBoundary: function getErrorBoundary() {
      return _js["default"].getPlugin('react').createErrorBoundary(React);
    },
    log: log
  };
};
var _default = bugsnagFactory;
exports["default"] = _default;